import { styled } from '@mui/material'
import { SeenIcon } from '$common/icons/seen'
import { ReceivedIcon } from '$common/icons/received'
import { SentIcon } from '$common/icons/sent'
import { PendingIcon } from '$common/icons/pending'
import { useOpenedRoomId } from '$logic/opened-room'
import { useRoomAttribute } from '$logic/room/react-hook'
import { useSendStatus } from '$comp/_app/components/chat/components/body/components/messageList/messages/components/time-and-status/send-status.react-hooks'

const Root = styled('div')`
  display: flex;
  align-items: center;
  /* @noflip */
  margin-right: 4px;
  color: ${({ theme }) => theme.palette.neutral000};
`

const StatusIconMap = {
  PENDING: <PendingIcon sx={{ width: '20px', height: '14px' }} />,
  SENT: <SentIcon />,
  RECEIVED: <ReceivedIcon />,
  SEEN: <SeenIcon />,
}

export function SendStatus({ iid }: { iid: number }) {
  const openedRoomId = useOpenedRoomId()

  const roomType = useRoomAttribute('type', openedRoomId)
  const status = useSendStatus(iid, openedRoomId)
  if (!roomType) return null

  // CHANNEL / PRIVATE_SPACE: only if pending
  if (roomType === 'CHANNEL' || roomType === 'PRIVATE_SPACE')
    return iid ? null : <Root>{StatusIconMap.PENDING}</Root>

  // GROUP / WAPP_ROOM / PV: only if fromMe (all statuses)
  return !!status && <Root>{StatusIconMap[status]}</Root>
}
